import { parseDate } from '@superdispatch/dates';
import {
  yupBoolean,
  yupDateString,
  yupNumber,
  yupObject,
  yupString,
} from 'shared/utils/YupUtils';
import { InferType, string } from 'yup';

export const CARRIER_COMMENT_MAX_LENGTH = 160;

export type PostingRequestPayloadDTO = InferType<
  typeof postingRequestPayloadSchema
>;
export const postingRequestPayloadSchema = yupObject({
  price: yupNumber().positive().required(),
  posting_guid: string().defined().nullable().default(null),
  carrier_contact_name: yupString(),
  carrier_comment: yupString().max(CARRIER_COMMENT_MAX_LENGTH).optional(),
  is_counter_bid: yupBoolean().default(false),
  pickup_date: yupDateString('JodaISO').required('Select Pickup Date'),
  delivery_date: yupDateString('JodaISO')
    .required('Select Delivery Date')
    .test(
      'validatePickupDelivery',
      'Date must be on or after Pickup Date',
      (value, context) => {
        const parent = context.parent as PostingRequestPayloadDTO;
        const pickupDate = parseDate(parent.pickup_date, { format: 'JodaISO' });
        const deliveryDate = parseDate(value, { format: 'JodaISO' });

        return pickupDate <= deliveryDate;
      },
    ),
});

export type PostingRequestValuesDTO = InferType<
  typeof postingRequestValuesSchema
>;
export const postingRequestValuesSchema = postingRequestPayloadSchema.shape({
  $is_agree: yupBoolean()
    .default(true)
    .test(
      'agree',
      'Please view and accept "Terms and Conditions"',
      (value) => !!value,
    ),
});
